export default __webpack_public_path__ + "static/media/selfi.0df4b156.png";